export enum DOWNLOAD_KEYS {
  CONTRACT_TRANSACTIONS = 'contractTransactions',
  CONTRACT_WORKBOOK = 'contractWorkbook',
}
